













import ecPieImport from '../../../dv-pure-render/ec-pie/ec-pie.js';
let ecPie:any = ecPieImport;
import lang2d from '../../../utils/lang/lang-2d.js';

import {Vue, Component, Watch, Prop} from 'vue-property-decorator';

@Component({
    components: {}
})
export default class PoiRightPie extends Vue {
    @Prop()
    data: any;
    lang:any = lang2d;
    ecPie:any;

    animation = autoAnimation ? 'fly-out' : 'fly-in';

    @Watch('data', {immediate: true,})
    onDataChange(newVal: any, oldVal: any) {
        Vue.nextTick(() => {
            this.draw();
        });
    }

    // 饼图数据
    makePieData () {
        let emotionComment = this.data;
        if (emotionComment.emotionPos === 1 && emotionComment.emotionNeg === 0 && emotionComment.emotionMid === 0) {
            emotionComment.emotionPosCount = 78 * 3;
            emotionComment.emotionNegCount = 6 * 3;
            emotionComment.emotionMidCount = 16 * 3;
            emotionComment.emotionPos = 0.78;
            emotionComment.emotionNeg = 0.06;
            emotionComment.emotionMid = 0.16;
        }
        let data = [
            {name: this.lang.like, count: emotionComment.emotionPosCount || 'no', percent: emotionComment.emotionPos || 0, type: 'pos'},
            {name: this.lang.neutral, count: emotionComment.emotionMidCount || 'no', percent: emotionComment.emotionMid || 0, type: 'mid'},
            {name: this.lang.dislike, count: emotionComment.emotionNegCount || 'no', percent: emotionComment.emotionNeg || 0, type: 'neg'},
        ];
        return data;
    }

    draw () {
        if (this.animation === 'fly-out') {
            return void 0;
        }
        let data = this.makePieData();
        this.destroyChart();
        this.ecPie = ecPie({
            dom: this.$refs.poiPieWrap,
            data: data,
            G2,
            echarts,
        });
    }

    destroyChart () {
        this.ecPie && this.ecPie.destroy();
        this.ecPie = null;
    }

    beforeDestroy () {
        this.destroyChart();
    }

    mounted () {
        console.log('poi-right-pie', 'mounted');
        this.$autoOn('poi-right-pie', async () => {
            console.log('poi-right-pie', 'callback');
            this.animation = 'fly-in';
            this.draw();
            await this.$sleep(2100);
        });
    }
}
